const actionTypes = {
    SET_PRODUCT_SAMPLE: 'SET_PRODUCT_SAMPLE'
};

export default actionTypes;
